/**
 * Data Processing Addendum (DPA) Page
 * Public legal page accessible without authentication
 * For B2B / Partners
 */

import LegalPageLayout from '@/components/legal/LegalPageLayout';
import { LEGAL_LAST_UPDATED } from '@/constants/legalVersions';

export default function DPAPage() {
  return (
    <LegalPageLayout 
      title="Data Processing Addendum (DPA)" 
      lastUpdated={LEGAL_LAST_UPDATED.dpa}
      metaDescription="Data Processing Addendum for FinList - B2B and partner data processing terms and security measures."
    >
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
        This Data Processing Addendum applies where FinList processes personal data on behalf of 
        business customers or partners.
      </p>

      <section>
        <h2>1. Roles</h2>
        <ul>
          <li><strong>Controller</strong>: Business customer or partner</li>
          <li><strong>Processor</strong>: FinList</li>
        </ul>
      </section>

      <section>
        <h2>2. Scope of Processing</h2>
        <p>FinList processes personal data solely to provide agreed services, including:</p>
        <ul>
          <li>Financial organization tools</li>
          <li>Shared household or team lists</li>
          <li>Analytics and reporting</li>
        </ul>
      </section>

      <section>
        <h2>3. Security Measures</h2>
        <p>FinList implements appropriate technical and organizational measures including:</p>
        <ul>
          <li>Encryption at rest and in transit</li>
          <li>Role-based access control</li>
          <li>Audit logging</li>
        </ul>
      </section>

      <section>
        <h2>4. Sub-processors</h2>
        <p>
          FinList may engage sub-processors (e.g. cloud infrastructure, payments, AI providers). 
          A current list can be requested.
        </p>
      </section>

      <section>
        <h2>5. International Transfers</h2>
        <p>
          Where data is transferred outside the UK, EU, US, or Africa, safeguards such as 
          Standard Contractual Clauses are applied.
        </p>
      </section>

      <section>
        <h2>6. Data Subject Rights</h2>
        <p>FinList will assist controllers in responding to data subject requests.</p>
      </section>

      <section>
        <h2>7. Data Breach Notification</h2>
        <p>
          FinList will notify partners without undue delay upon becoming aware of a personal data breach.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>For DPA inquiries or to request the current sub-processor list:</p>
        <p>
          📧 <a href="mailto:privacy@getfinlist.com">privacy@getfinlist.com</a>
        </p>
      </section>
    </LegalPageLayout>
  );
}
